/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  const { currentUser } = initialState ?? {};
  return {
    canAdmin: currentUser && currentUser.access === 'admin',
    canUser: currentUser && currentUser.access === 'user',
    canReview: currentUser && currentUser.access === 'reviewer',
    canSdkUser: currentUser && currentUser.access === 'sdkuser',
    // 新增权限判断
    canAdminOrReview: (currentUser && currentUser.access === 'admin') || (currentUser && currentUser.access === 'reviewer'),
    canAdminOrUser: (currentUser && currentUser.access === 'admin') || (currentUser && currentUser.access === 'user'),
    canAdminOrSdkUser: (currentUser && currentUser.access === 'admin') || (currentUser && currentUser.access === 'sdkuser'),
    canUserOrSdkUser: (currentUser && currentUser.access === 'user') || (currentUser && currentUser.access === 'sdkuser'),

    canAdminOrReviewOrUser: (currentUser && currentUser.access === 'admin') || (currentUser && currentUser.access === 'reviewer') || (currentUser && currentUser.access === 'user'),
    canAdminOrReviewOrSdkUser: (currentUser && currentUser.access === 'admin') || (currentUser && currentUser.access === 'reviewer') || (currentUser && currentUser.access === 'sdkuser'),
    
    canAdminOrReviewOrUserOrSdkUser: (currentUser && currentUser.access === 'admin') || (currentUser && currentUser.access === 'reviewer') || (currentUser && currentUser.access === 'user') || (currentUser && currentUser.access === 'sdkuser'),
  };
}
